import {useMemo, useEffect, useState} from "react";
import * as React from "react";
import {DemoContainer} from "@mui/x-date-pickers/internals/demo";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  Alert,
  Box,
  Card,
  Checkbox,
  Container,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  MenuItem,
  Select,
  Typography
} from "@mui/material";
import MDButton from "components/MDButton";
import dayjs from "dayjs";
import {CloudUpload, Label} from "@mui/icons-material";
import axios from "axios";
import {BASE_URL, PATCH, GET} from "APIclient";
import FileSaver, {saveAs} from "file-saver";
import Snackbar from "@mui/material/Snackbar";
import {useLocation} from "react-router-dom";
import properties from "constants/ApplicationConstants";

function EmployeeDocument() {
  const [uploadedFile, setUploadedFile] = useState({});
  const [formData, setFormData] = useState({
    marksheetI: "",
    marksheetII: "",
    graduation: "",
    drivingLicense: "",
    electionCard: "",
    pancardNo: "",
    nameInPancard: "",
    passportNo: "",
    nameInPassport: "",
    passportValidFrom: null,
    passportValidTo: null,
    dlNo: "",
    nameInDl: "",
    dlValidTo: null,
    ecNo: "",
    nameInEc: "",
    aadhaarNo: "",
    nameInAc: "",
    postGraduation: "",
    other1: "",
    other2: "",
    other3: ""
  });

  const [snakMessage, setSnakMessage] = React.useState("");
  const [snakColor, setSnakColor] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [snackbar, setSnackbar] = React.useState(null);
  const handleCloseSnackbar = () => setSnackbar(null);
  const handleClose = () => {
    setOpen(false);
  };

  const [isEdited, setIsEdited] = useState(false);
  const location = useLocation();
  const empId = location.state || window.sessionStorage.getItem("empId");

  const [hasDocumentDetailsPermission, setHasDocumentDetailsPermission] = useState(false);

  const url1 = `employee/employee-details/${empId}`;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await GET(url1);
        const data = response?.data?.data;
        if (data && response?.data?.statusCode === 200) {
          setFormData({
            ...formData,
            pancardNo: data.employee?.pancardNo || "",
            nameInPancard: data.employee?.nameInPancard || "",
            passportNo: data.employee?.passportNo || "",
            nameInPassport: data.employee?.nameInPassport || "",
            passportValidFrom: data.employee?.passportValidFrom
              ? dayjs(data.employee.passportValidFrom).format("YYYY-MM-DD")
              : null,
            passportValidTo: data.employee?.passportValidTo
              ? dayjs(data.employee.passportValidTo).format("YYYY-MM-DD")
              : null,
            dlNo: data.employee?.dlNo || "",
            nameInDl: data.employee?.nameInDl || "",
            dlValidTo: data.employee?.dlValidTo
              ? dayjs(data.employee.dlValidTo).format("YYYY-MM-DD")
              : null,
            ecNo: data.employee?.ecNo || "",
            nameInEc: data.employee?.nameInEc || "",
            aadhaarNo: data.employee?.aadhaarNo || "",
            adharcard: data.documents?.adharcard || "",
            nameInAc: data.employee?.nameInAc || "",
            marksheetI: data.documents?.marksheetI || "",
            marksheetII: data.documents?.marksheetII || "",
            graduation: data.documents?.degree || "",
            pancard: data.documents?.pancard || "",
            postGraduation: data.documents?.postGraduation || "",
            other1: data.documents?.other1 || "",
            other2: data.documents?.other2 || "",
            other3: data.documents?.other3 || ""
          });
          setHasDocumentDetailsPermission(data?.employee.permissions.includes("documents"));
          console.log("Permissions:", data?.employee.permissions);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const [errors, setErrors] = useState({
    pancardNo: "",
    nameInPancard: "",
    passportNo: "",
    nameInPassport: "",
    dlNo: "",
    nameInDl: "",
    ecNo: "",
    nameInEc: "",
    aadhaarNo: "",
    nameInAc: "",
    marksheetI: "",
    marksheetII: "",
    graduation: "",
    postGraduation: "",
    passportValidFrom: "",
    passportValidTo: "",
    dlValidTo: "",
    other1: "",
    other2: "",
    other3: ""
  });

  const validateField = (name, value) => {
    let errorMessage = "";

    if (name === "pancardNo") {
      if (value.trim() === "") {
        errorMessage = "PAN Card Number is required.";
      } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value)) {
        errorMessage = "Invalid PAN Card format.";
      }
    } else if (name === "nameInPancard") {
      if (value.trim() === "") {
        errorMessage = "Name in PAN Card is required.";
      } else if (!/^[A-Za-z\s,.-]+$/.test(value)) {
        errorMessage = "Name in PAN Card should not contain numbers.";
      } else if (value.length > 40) {
        errorMessage = "Name in PAN Card should not exceed 30 characters.";
      }
    }
    // else if (name === "ecNo") {
    //   if (value.trim() === "") {
    //     errorMessage = "Election Card Number is required.";
    //   } else if (!/^[A-Z0-9]{10}$/.test(value)) {
    //     errorMessage = "Invalid Election Card Number format.";
    //   }
    // } else if (name === "nameInEc") {
    //   if (value.trim() === "") {
    //     errorMessage = "Name in Election Card is required.";
    //   } else if (!/^[A-Za-z\s,.-]+$/.test(value)) {
    //     errorMessage = "Name in Election Card should not contain numbers.";
    //   } else if (value.length > 25) {
    //     errorMessage = "Name in Election Card should not exceed 25 characters.";
    //   }
    // }
    else if (name === "aadhaarNo") {
      const aadhaarPattern = /^[2-9]{1}[0-9]{11}$/;
      if (value.trim() === "") {
        errorMessage = "Aadhaar is required.";
      } else if (!aadhaarPattern.test(value)) {
        errorMessage = "Enter valid 12-digit Aadhaar.";
      } else if (/^(\d)\1{11}$/.test(value)) {
        errorMessage = "Aadhaar cannot be all same digits.";
      }
    } else if (name === "nameInAc") {
      if (value.trim() === "") {
        errorMessage = "Name in Aadhaar Card is required.";
      } else if (!/^[A-Za-z\s,.-]+$/.test(value)) {
        errorMessage = "Name in Aadhaar Card should not contain numbers.";
      } else if (value.length > 40) {
        errorMessage = "Name in Aadhaar Card should not exceed 25 characters.";
      }
    }
    // else if (name === "marksheetI") {
    //   if (!value || value === "") {
    //     errorMessage = "SSC Marksheet is required.";
    //   }
    // } else if (name === "marksheetII") {
    //   if (!value || value === "") {
    //     errorMessage = "HSC Marksheet is required.";
    //   }
    // } else if (name === "graduation") {
    //   if (!value || value === "") {
    //     errorMessage = "Graduation Degree is required.";
    //   }
    // } else if (name === "pancard") {
    //   if (!value || value === "") {
    //     errorMessage = "PAN Card upload is required.";
    //   }
    // } else if (name === "adharcard") {
    //   if (!value || value === "") {
    //     errorMessage = "Aadhaar Card upload is required.";
    //   }
    // }
    // else if (name === "passportNo" && value.trim() !== "") {
    //   if (!/^[A-PR-WY][1-9]\d{7}$/.test(value)) {
    //     errorMessage = "Invalid Passport Number format.";
    //   }
    // } else if (name === "nameInPassport" && value.trim() !== "") {
    //   if (!/^[A-Za-z\s,.-]+$/.test(value)) {
    //     errorMessage = "Name in Passport should not contain numbers.";
    //   }
    // } else if (name === "dlNo" && value.trim() !== "") {
    //   if (!/^[A-Z]{2}[0-9]{13}$/.test(value)) {
    //     errorMessage = "Invalid Driving License Number format.";
    //   }
    // } else if (name === "nameInDl" && value.trim() !== "") {
    //   if (!/^[A-Za-z\s,.-]+$/.test(value)) {
    //     errorMessage = "Name in Driving License should not contain numbers.";
    //   }
    // } else if (name === "passportValidFrom" && value) {
    //   const validFrom = dayjs(value);
    //   const validTo = dayjs(formData.passportValidTo);
    //   if (validFrom.isValid() && validTo.isValid() && validFrom.isAfter(validTo)) {
    //     errorMessage = "Valid From date cannot be after Valid To date.";
    //   }
    // } else if (name === "passportValidTo" && value) {
    //   const validTo = dayjs(value);
    //   const validFrom = dayjs(formData.passportValidFrom);
    //   if (validFrom.isValid() && validTo.isValid() && validTo.isBefore(validFrom)) {
    //     errorMessage = "Valid To date cannot be before Valid From date.";
    //   }
    // } else if (name === "dlValidTo" && value) {
    //   const validTo = dayjs(value);
    //   const today = dayjs();
    //   if (validTo.isValid() && validTo.isBefore(today)) {
    //     errorMessage = "Driving License Valid To date cannot be in the past.";
    //   }
    // }

    return errorMessage;
  };

  const validateAllFields = () => {
    const newErrors = {...errors};
    let hasError = false;

    Object.keys(formData).forEach(key => {
      const errorMessage = validateField(key, formData[key]);
      newErrors[key] = errorMessage;
      if (errorMessage) {
        hasError = true;
      }
    });

    setErrors(newErrors);
    return !hasError;
  };

  const handleChange = e => {
    if (!hasDocumentDetailsPermission) return;

    const {name, value, files} = e.target;
    const newValue = name === "pancardNo" ? value.toUpperCase() : value;
    setFormData(prevInputs => ({
      ...prevInputs,
      [name]: files ? files[0] : newValue
    }));
    setErrors(prevErrors => ({
      ...prevErrors,
      [name]: validateField(name, files ? files[0] : newValue)
    }));
    if (files) {
      console.log("File selected for", name, ":", files[0]);
      setUploadedFile(prev => ({...prev, [name]: files[0]}));
    }
    if (value !== formData[name]) {
      setIsEdited(true);
    }
    console.log("Degree error:", errors.degree);
  };

  const handleDateChange = (date, field) => {
    if (!hasDocumentDetailsPermission) return;

    const validDate = date ? dayjs(date) : null;
    setFormData(prev => ({
      ...prev,
      [field]: validDate?.isValid() ? validDate.format("YYYY-MM-DD") : null
    }));
    const newErrors = {
      ...errors,
      [field]: validateField(field, validDate?.isValid() ? validDate.format("YYYY-MM-DD") : null)
    };
    if (field === "passportValidFrom") {
      newErrors.passportValidTo = validateField("passportValidTo", formData.passportValidTo);
    } else if (field === "passportValidTo") {
      newErrors.passportValidFrom = validateField("passportValidFrom", formData.passportValidFrom);
    }
    setErrors(newErrors);
    setIsEdited(true);
  };

  const handleSubmit = async () => {
    if (!hasDocumentDetailsPermission) return;

    if (!validateAllFields()) {
      return;
    }

    const url = `${BASE_URL}/employee/document-details`;

    const bodyFormData = new FormData();
    bodyFormData.append("empId", parseInt(empId).toString());

    Object.entries(formData).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        for (let file of value) {
          if (value !== "" && value !== null) {
            bodyFormData.append(key, file);
          }
        }
      } else if (value instanceof File) {
        if (value !== "" && value !== null) {
          bodyFormData.append(key, value);
        }
      } else {
        if (value !== "" && value !== null) {
          bodyFormData.append(key, value);
        }
      }
    });

    for (let [key, value] of bodyFormData.entries()) {
      console.log("FormData:", key, value);
    }

    try {
      const response = await axios.patch(url, bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${window.sessionStorage.getItem("jwtToken")}`
        }
      });
      if (response?.status === 200) {
        setSnakColor("success");
        setSnakMessage("Documents details updated successfully.");
        setOpen(true);
        setIsEdited(false);
        setUploadedFile({});
      }
    } catch (error) {
      setSnakMessage(error.response?.data?.message || "Failed to save documents.");
      setSnakColor("error");
      setOpen(true);
    }
  };

  return (
    <Container>
      <MDBox px={2}>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            <Section>
              <InputLabel sx={{fontWeight: "bold", fontFamily: properties.fontFamily}}>
                PAN Card Details
                <span style={{color: properties.colors.Red}}>*</span>
              </InputLabel>
              <MDInput
                sx={{m: 1, width: "30ch"}}
                type="text"
                name="pancardNo"
                value={formData.pancardNo}
                onChange={handleChange}
                label={
                  <span>
                    PAN Card No<span style={{color: properties.colors.Red}}>*</span>
                  </span>
                }
                variant="standard"
                error={!!errors.pancardNo}
                helperText={errors.pancardNo}
                disabled={!hasDocumentDetailsPermission}
              />
              <MDInput
                sx={{m: 1, width: "30ch"}}
                type="text"
                name="nameInPancard"
                value={formData.nameInPancard}
                onChange={handleChange}
                label={
                  <span>
                    Name in PAN Card<span style={{color: properties.colors.Red}}>*</span>
                  </span>
                }
                variant="standard"
                error={!!errors.nameInPancard}
                helperText={errors.nameInPancard}
                disabled={!hasDocumentDetailsPermission}
              />
              <FileUploadButton
                label={
                  <span>
                    Upload PAN Card<span style={{color: properties.colors.Red}}>*</span>
                  </span>
                }
                name="pancard"
                onChange={handleChange}
                fileLink={BASE_URL + "/employee/view/" + empId + "/pancard"}
                localFile={uploadedFile.pancard}
                error={errors.pancard}
                disabled={!hasDocumentDetailsPermission}
              />
            </Section>

            <Section>
              <InputLabel sx={{fontWeight: "bold", fontFamily: properties.fontFamily}}>
                Aadhaar Card Details
                <span style={{color: properties.colors.Red}}>*</span>
              </InputLabel>
              <MDInput
                sx={{m: 1, width: "30ch"}}
                type="text"
                value={formData.aadhaarNo}
                name="aadhaarNo"
                onChange={handleChange}
                label={
                  <span>
                    Aadhaar Card No.<span style={{color: properties.colors.Red}}>*</span>
                  </span>
                }
                variant="standard"
                error={!!errors.aadhaarNo}
                helperText={errors.aadhaarNo}
                disabled={!hasDocumentDetailsPermission}
              />
              <MDInput
                sx={{m: 1, width: "30ch"}}
                type="text"
                value={formData.nameInAc}
                name="nameInAc"
                onChange={handleChange}
                label={
                  <span>
                    Name in Aadhaar Card<span style={{color: properties.colors.Red}}>*</span>
                  </span>
                }
                variant="standard"
                error={!!errors.nameInAc}
                helperText={errors.nameInAc}
                disabled={!hasDocumentDetailsPermission}
              />
              <FileUploadButton
                label={
                  <span>
                    Upload Aadhaar Card<span style={{color: properties.colors.Red}}>*</span>
                  </span>
                }
                name="adharcard"
                onChange={handleChange}
                fileLink={BASE_URL + "/employee/view/" + empId + "/adharcard"}
                localFile={uploadedFile.adharcard}
                error={errors.adharcard}
                disabled={!hasDocumentDetailsPermission}
              />
            </Section>

            <Section>
              <InputLabel sx={{fontWeight: "bold", fontFamily: properties.fontFamily}}>
                Passport Details
              </InputLabel>
              <MDInput
                sx={{m: 1, width: "30ch"}}
                type="text"
                name="passportNo"
                value={formData.passportNo}
                onChange={handleChange}
                label="Passport No"
                variant="standard"
                error={!!errors.passportNo}
                helperText={errors.passportNo}
                disabled={!hasDocumentDetailsPermission}
              />
              <MDInput
                sx={{m: 1, width: "30ch"}}
                type="text"
                name="nameInPassport"
                value={formData.nameInPassport}
                onChange={handleChange}
                label="Name in Passport"
                variant="standard"
                error={!!errors.nameInPassport}
                helperText={errors.nameInPassport}
                disabled={!hasDocumentDetailsPermission}
              />
              <Box sx={{display: "flex", gap: 3, pt: 1}}>
                <DateInput
                  label="Valid From"
                  name="passportValidFrom"
                  value={formData.passportValidFrom}
                  onChange={date => handleDateChange(date, "passportValidFrom")}
                  disabled={!hasDocumentDetailsPermission}
                  error={!!errors.passportValidFrom}
                  helperText={errors.passportValidFrom}
                />
                <DateInput
                  label="Valid To"
                  name="passportValidTo"
                  value={formData.passportValidTo}
                  onChange={date => handleDateChange(date, "passportValidTo")}
                  disabled={!hasDocumentDetailsPermission}
                  error={!!errors.passportValidTo}
                  helperText={errors.passportValidTo}
                />
              </Box>
              <FileUploadButton
                label="Upload Passport"
                name="passport"
                onChange={handleChange}
                fileLink={BASE_URL + "/employee/view/" + empId + "/passport"}
                localFile={uploadedFile.passport}
                error={errors.passport}
                disabled={!hasDocumentDetailsPermission}
              />
            </Section>

            <Section>
              <InputLabel sx={{fontWeight: "bold", fontFamily: properties.fontFamily}}>
                Driving License Details
              </InputLabel>
              <MDInput
                sx={{m: 1, width: "30ch"}}
                type="text"
                name="dlNo"
                value={formData.dlNo}
                onChange={handleChange}
                label="License No."
                variant="standard"
                error={!!errors.dlNo}
                helperText={errors.dlNo}
                disabled={!hasDocumentDetailsPermission}
              />
              <MDInput
                sx={{m: 1, width: "30ch"}}
                type="text"
                name="nameInDl"
                value={formData.nameInDl}
                onChange={handleChange}
                label="Name"
                variant="standard"
                error={!!errors.nameInDl}
                helperText={errors.nameInDl}
                disabled={!hasDocumentDetailsPermission}
              />
              <Box sx={{display: "flex", gap: 3}}>
                <DateInput
                  label="Valid To"
                  name="dlValidTo"
                  value={formData.dlValidTo}
                  onChange={date => handleDateChange(date, "dlValidTo")}
                  disabled={!hasDocumentDetailsPermission}
                  error={!!errors.dlValidTo}
                  helperText={errors.dlValidTo}
                />
                <FileUploadButton
                  label="Upload Driving License"
                  name="drivingLicense"
                  onChange={handleChange}
                  fileLink={BASE_URL + "/employee/view/" + empId + "/drivingLicense"}
                  localFile={uploadedFile.drivingLicense}
                  error={errors.drivingLicense}
                  disabled={!hasDocumentDetailsPermission}
                />
              </Box>
            </Section>

            <Section>
              <InputLabel sx={{fontWeight: "bold", fontFamily: properties.fontFamily}}>
                Election Card Details
              </InputLabel>
              <MDInput
                sx={{m: 1, width: "30ch"}}
                type="text"
                name="ecNo"
                value={formData.ecNo}
                onChange={handleChange}
                label="Election Card No."
                variant="standard"
                disabled={!hasDocumentDetailsPermission}
              />
              <MDInput
                sx={{m: 1, width: "30ch"}}
                type="text"
                name="nameInEc"
                value={formData.nameInEc}
                onChange={handleChange}
                label="Name in Election Card"
                variant="standard"
                disabled={!hasDocumentDetailsPermission}
              />
              <FileUploadButton
                label="Upload Election Card"
                name="electionCard"
                onChange={handleChange}
                fileLink={BASE_URL + "/employee/view/" + empId + "/electionCard"}
                localFile={uploadedFile.electionCard}
                disabled={!hasDocumentDetailsPermission}
              />
            </Section>

            <Section>
              <InputLabel sx={{mb: 1, fontWeight: "bold", fontFamily: properties.fontFamily}}>
                Documents Upload
              </InputLabel>
              <MDBox sx={{display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 2}}>
                <FileUploadButton
                  label={
                    <span>
                      Upload SSC<span style={{color: properties.colors.Red}}>*</span>
                    </span>
                  }
                  name="marksheetI"
                  onChange={handleChange}
                  fileLink={BASE_URL + "/employee/view/" + empId + "/marksheetI"}
                  localFile={uploadedFile.marksheetI}
                  error={errors.marksheetI}
                  disabled={!hasDocumentDetailsPermission}
                />
                <FileUploadButton
                  label={
                    <span>
                      Upload HSC<span style={{color: properties.colors.Red}}>*</span>
                    </span>
                  }
                  name="marksheetII"
                  onChange={handleChange}
                  fileLink={BASE_URL + "/employee/view/" + empId + "/marksheetII"}
                  localFile={uploadedFile.marksheetII}
                  error={errors.marksheetII}
                  disabled={!hasDocumentDetailsPermission}
                />
              </MDBox>
              <MDBox sx={{display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 2}}>
                <FileUploadButton
                  label={
                    <span>
                      Upload Graduation<span style={{color: properties.colors.Red}}>*</span>
                    </span>
                  }
                  name="graduation"
                  onChange={handleChange}
                  fileLink={BASE_URL + "/employee/view/" + empId + "/graduation"}
                  localFile={uploadedFile.graduation}
                  error={errors.graduation}
                  disabled={!hasDocumentDetailsPermission}
                />
                <FileUploadButton
                  label="Upload Postgraduation"
                  name="postGraduation"
                  onChange={handleChange}
                  fileLink={BASE_URL + "/employee/view/" + empId + "/postGraduation"}
                  localFile={uploadedFile.postGraduation}
                  error={errors.postGraduation}
                  disabled={!hasDocumentDetailsPermission}
                />
              </MDBox>
              <MDBox sx={{display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 2}}>
                <FileUploadButton
                  label="Other1"
                  name="other1"
                  onChange={handleChange}
                  fileLink={BASE_URL + "/employee/view/" + empId + "/other1"}
                  localFile={uploadedFile.other1}
                  error={errors.other1}
                  disabled={!hasDocumentDetailsPermission}
                />
                <FileUploadButton
                  label="Other2"
                  name="other2"
                  onChange={handleChange}
                  fileLink={BASE_URL + "/employee/view/" + empId + "/other2"}
                  localFile={uploadedFile.other2}
                  error={errors.other2}
                  disabled={!hasDocumentDetailsPermission}
                />
              </MDBox>
              <MDBox sx={{display: "grid", gridTemplateColumns: "repeat(1, 1fr)", gap: 2}}>
                <FileUploadButton
                  label="Other3"
                  name="other3"
                  onChange={handleChange}
                  fileLink={BASE_URL + "/employee/view/" + empId + "/other3"}
                  localFile={uploadedFile.other3}
                  error={errors.other3}
                  disabled={!hasDocumentDetailsPermission}
                />
              </MDBox>
            </Section>
            <MDBox mt={4} mb={1} sx={{textAlign: "right"}}>
              <MDButton
                variant="gradient"
                color="info"
                sx={{width: "30ch", background: properties.colors.bgcolorbluethem}}
                onClick={handleSubmit}
                disabled={!hasDocumentDetailsPermission || !isEdited}
              >
                Save
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
        <Snackbar
          open={open}
          anchorOrigin={{vertical: "top", horizontal: "right"}}
          autoHideDuration={6000}
          onClose={handleClose}
        >
          <Alert
            onClose={handleClose}
            severity={snakColor === "success" ? "success" : "error"}
            variant="filled"
            sx={{width: "100%", color: "#fff"}}
          >
            {snakMessage}
          </Alert>
        </Snackbar>
      </MDBox>
    </Container>
  );
}

function Section({title, children}) {
  return (
    <MDBox mb={6}>
      <InputLabel sx={{fontWeight: "bold", fontSize: "16px"}}>{title}</InputLabel>
      {children}
    </MDBox>
  );
}

function DateInput({label, name, value, onChange, disabled, error, helperText}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={["DatePicker"]}>
        <DatePicker
          format="DD/MM/YYYY"
          sx={{m: 1, width: "30ch"}}
          size="small"
          label={label}
          name={name}
          value={value ? dayjs(value) : null}
          onChange={newDate => onChange(newDate)}
          disabled={disabled}
          slotProps={{
            textField: {
              error: error,
              helperText: helperText
            }
          }}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
}

function FileUploadButton({label, name, onChange, fileLink, localFile, disabled, error}) {
  const handleViewFile = async fileLink => {
    try {
      console.log("View file clicked!");
      const headers = {
        Accept: "application/octet-stream",
        Authorization: `Bearer ${window.sessionStorage.getItem("jwtToken")}`
      };
      const response = await axios.get(fileLink, {
        headers: headers,
        responseType: "blob",
        withCredentials: true
      });
      if (response.status === 200) {
        const contentType = response.headers["content-type"] || "application/octet-stream";
        const fileBlob = new Blob([response.data], {type: contentType});
        const fileUrl = URL.createObjectURL(fileBlob);
        window.open(fileUrl, "_blank");
      } else {
        console.error("Failed to fetch the file:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching file:", error);
    }
  };

  const handlePreviewFile = () => {
    if (localFile) {
      const fileUrl = URL.createObjectURL(localFile);
      window.open(fileUrl, "_blank");
    }
  };

  return (
    <MDBox sx={{display: "flex", flexDirection: "column", gap: 1}}>
      <MDBox sx={{display: "flex", alignItems: "center", gap: 1}}>
        <MDButton
          component="label"
          variant="contained"
          sx={{m: 1, width: "40ch", p: 1}}
          startIcon={<CloudUpload />}
          disabled={disabled}
        >
          {label}
          <input
            type="file"
            name={name}
            onChange={onChange}
            hidden
            accept=".pdf,.jpg,.jpeg,.png"
            disabled={disabled}
          />
        </MDButton>
        {(fileLink || localFile) && (
          <MDButton
            color="white"
            startIcon={<VisibilityIcon />}
            onClick={localFile ? handlePreviewFile : () => handleViewFile(fileLink)}
          >
            {localFile ? "Preview" : "View"}
          </MDButton>
        )}
      </MDBox>
      {error && (
        <Typography color="error" variant="caption" sx={{ml: 1}}>
          {error}
        </Typography>
      )}
    </MDBox>
  );
}

export default EmployeeDocument;
